import { Immunoglobulin } from "../../../models/Immunoglobulin";
import { Box } from "@mui/material";
import WhiteCardInfo from "../../typographies/WhiteCardInfo";
import { useStoreContext } from "../../..";

interface Props {
  immunoglobulin: Immunoglobulin;
}

const ImmunoglobulinDetails = ({ immunoglobulin }: Props) => {
  const { fieldStore } = useStoreContext();
  const drugName = fieldStore.mappedDrugs?.get(Number(immunoglobulin.drug));
  const sideEffects = immunoglobulin.adverseEvent;
  const effects = sideEffects
    ? sideEffects.split(",").map((a) => Number(a))
    : [];
  let sideEffectsStr = "Biverkningar:";
  effects.forEach((sideEffect) => {
    sideEffectsStr +=
      (sideEffectsStr === "Biverkningar:" ? "" : ",") +
        " " +
        fieldStore.mappedSideEffects?.get(sideEffect) || sideEffect;
  });

  return (
    <Box className="flex-column-start-start">
      <WhiteCardInfo text={immunoglobulin.date.substring(0, 10)} />
      <WhiteCardInfo text={`Läkemedel: ${drugName || immunoglobulin.drug}`} />
      <WhiteCardInfo text={`Dos: ${immunoglobulin.dosage}`} />
      {immunoglobulin.batch && (
        <WhiteCardInfo text={` Batchnummer: ${immunoglobulin.batch}`} />
      )}
      <WhiteCardInfo text={sideEffectsStr} />
    </Box>
  );
};

export default ImmunoglobulinDetails;
